import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as SiteQL from "queries/site";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import { Mutation, Button } from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params,
    params: { siteId },
  },
}) => {
  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            Removing the site <b>{siteId}</b>? This action will be permanent and
            can't be undone.
          </Col>
        </Row>
        <Row>
          <Col>
            {/* Said plainly because both halves of it are true and neither is
                obvious. The pages and sections DO go now — P138 built the
                cascade — but not inside this mutation: it marks the site, which
                hides it immediately, and a drain empties the two tables behind
                it (docs/pagews.md §Deleting a site). What a person can observe
                from that is the second sentence: the site is gone from here at
                once, and the name it held is not free again until the content
                has actually been removed. Somebody retyping the same name a
                second later gets "that site is still being removed", and this is
                where they were told to expect it. */}
            <p className="text-muted mt-3 mb-0">
              Its pages and sections are deleted with it. The site disappears
              straight away; clearing its content takes a moment longer, and its
              name cannot be reused until that finishes.
            </p>
          </Col>
        </Row>
        <Mutation
          mutation={SiteQL.remove}
          update={SiteQL.update(params)}
          onMutate={({ handler }) => {
            handler({ variables: { siteId } });
          }}
          onCompleted={() => {
            history.replace(`/site`);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Row>
      <Col>
        <Button onClick={() => mutate()}>Remove</Button>
      </Col>
    </Row>
  );
};
